import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

import OkLoader from "shared/components/OkLoader";
import Str from "shared/components/Str";

import {
	PACKAGES_FORM_NAMES,
} from "shared/payment/constants";

const {
	boostPackage,
} = PACKAGES_FORM_NAMES;


const Packages = ({
	isLoading,
	productPackages,
	selectedProductId,
	setSelectedProductPackage,
	toggleVisible,
	onBoostClick,
	className,
}) => (
	<form
		onChange={({ target: { value } }) => setSelectedProductPackage(value)}
		onSubmit={(e) => e.preventDefault()}
		className={classnames(className, {
			"boostpackages-packages": true,
		})}
	>
		<div className="boostpackages-packages-container">
			<OkLoader
				className={classnames({
					"boostpackages-packages-loader": true,
					"boostpackages-packages-loader--show": isLoading,
				})}
				show
			/>

			<div
				className={classnames({
					"boostpackages-packages-radios": true,
					"boostpackages-packages-radios--show": !isLoading,
				})}
			>
				{productPackages.map(({ id, name, formattedInitialUnitPrice }) => {
					return (
						<label
							htmlFor={`payment-radio-${id}`}
							className={classnames("boostpackages-packages-radio", {
								"boostpackages-packages-radio--checked": selectedProductId === id,
							})}
							key={id}
						>
							<input
								id={`payment-radio-${id}`}
								className="boostpackages-packages-radio-input"
								readOnly
								checked={selectedProductId === id}
								name={boostPackage}
								type="radio"
								value={id}
							/>
							<span
								className={classnames("boostpackages-packages-radio-button", {
									"boostpackages-packages-radio-button--checked": selectedProductId === id,
								})}
							/>
							<span className="boostpackages-packages-radio-name">
								{name}
							</span>
							{" "}
							for <span dangerouslySetInnerHTML={{ __html: formattedInitialUnitPrice }} /> each
						</label>
					);
				})}
				<div
					className="boostpackages-packages-button-container"
				>
					<button
						className="boostpackages-packages-boost-now"
						onClick={onBoostClick}
						type="button"
					>
						<Str>Boost now</Str>
					</button>
				</div>
				<div
					className="boostpackages-packages-button-container"
				>
					<button
						type="button"
						onClick={toggleVisible}
						className="boostpackages-packages-no-thanks"
					>
						<Str>No thanks</Str>
					</button>
				</div>
			</div>
		</div>
	</form>
);


Packages.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	productPackages: PropTypes.array.isRequired,
	selectedProductId: PropTypes.string,
	setSelectedProductPackage: PropTypes.func.isRequired,
	onBoostClick: PropTypes.func.isRequired,
	toggleVisible: PropTypes.func.isRequired,
	className: PropTypes.string,
};

Packages.defaultProps = {
	className: "",
	selectedProductId: null,
};

export default Packages;



// WEBPACK FOOTER //
// ./src/apps/boosts/components/ProductPackageScreen/Packages.jsx